export const PACKAGE_STATUSES = {
  0: 'DRAFT',
  1: 'PENDING',
  2: 'FINISHED',
  3: 'REJECT',
  4: 'REVOKED',
  5: 'EXPIRED',
  6: 'FAILED',
  7: 'SENDING',
  8: 'ERROR_ON_CONNECTIVE',
};

export const FILTERS = {
  'byStatuses': 'byStatuses',
  'byOwnerUsers': 'byOwnerUsers',
};

export const FILTERS_NAMES = {
  'byStatuses': 'Status',
  'byOwnerUsers': 'components.shared.filters.selectUserFilter.byOwnerUsers',
};
